import React, { useEffect, useMemo, useState } from 'react';
import { PageHeader, ResetFilterWrapper } from '../../../constants/style/common.styled';
import Heading from '../../../components/typography';
import Search from '../../../components/search/search';
import InitialValuesForm from '../../../constants/initialValues';
import {
  ModalStatusType,
  RolePublishFilterParamsType,
  TableParamsType,
} from '../../../types/common';
import Table from '../../../components/table';
import { RolePublishHeader } from '../../../constants/table-headers/rolePublishHeader';
import Button from '../../../components/button';
import {
  useAdvanceBoolean,
  useBoolean,
  useGetDestinationCompanies,
  useGetRoleOptions,
  useGetRolePublishList,
  useWealthlaneCustomerApi,
  useWealthlaneIdentityApi,
} from '../../../hooks';
import AnimationWrapper from '../../../components/animation/animationWrapper';
import RolePublishModal from './rolePublishModal';
import AlertPopup from '../../../components/alert-popup';
import FormSelect from '../../../components/dropdown/formSelect';
import Filter from '../../../components/filter';
import { RolePublishedToCompanyService } from '@wealthlane/api-services/wealthlane-identity-service';
import { toast } from 'react-toastify';
import ToastComponent from '../../../components/toast';
import { useQueryClient } from 'react-query';
import Spinners from '../../../components/spinner';
import {
  DynamicTable,
  withDynamicTableContext,
  useDynamicTable,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import { axiosInstance } from '../../../services/apiInterceptor';

const initialValues = {
  data: InitialValuesForm.rolePublishModal,
  id: '',
};

// const schemaData = {
//   columns: [
//     {
//       Header: 'Source Role',
//       accessor: 'roleName',
//       width: 280,
//       maxWidth: 280,
//       sortable: false,
//     },
//     {
//       Header: 'Destination Company',
//       accessor: 'companyName',
//       width: 150,
//       maxWidth: 500,
//       sortable: false,
//     },
//   ],
//   options: {
//     showToolbar: true,
//     showImportBlock: false,
//     showPagination: true,
//     showFilter: true,
//     showSearch: true,
//     filters: [
//       {
//         type: 'asyncSelect',
//         name: 'companyName',
//         placeholder: 'Company',
//         fetchFrom:
//           'api/customer/api/customer/customer-success/options/allowed-destination-companies',
//         mapper: {
//           label: 'name',
//           value: 'id',
//         },
//       },
//       {
//         type: 'asyncSelect',
//         name: 'roleName',
//         placeholder: 'Role',
//         fetchFrom: 'api/customer/api/customer/customer-success/options/self-roles',
//         mapper: {
//           label: 'name',
//           value: 'id',
//         },
//       },
//     ],
//     groupBy: ['roleName'],
//   },
// };

const RolePublish = () => {
  const { handleRequest } = useWealthlaneCustomerApi();
  const { handleRequest: identityHandleRequest } = useWealthlaneIdentityApi();
  const [searchQuery, setSearchQuery] = useState('');
  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const { tableInfo, setTableInfo } = useDynamicTable();

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);

  const [tableFilterInfo, setTableFilterInfo] = useState<RolePublishFilterParamsType>({
    companyName: '',
    roleName: '',
  });
  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false);
  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Add');
  const [initialData, setInitialData] = useState(initialValues);
  const [rowData, setRowData] = useState<any>();
  const [alertLoading, setAlertLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const { data: destinationCompaniesOption } = useGetDestinationCompanies(handleRequest);
  const { data: roleOption } = useGetRoleOptions(handleRequest);
  const {
    data: rolePublishList,
    isLoading,
    status,
  } = useGetRolePublishList(handleRequest, tableInfo);
  const queryClient = useQueryClient();
  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'ROLE_PUBLISH_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });
  const data = React.useMemo(() => rolePublishList?.items || [], [rolePublishList, isLoading]);
  const {
    value: isConfirmOpen,
    setFalse: closeConfirmModal,
    setTrue: openConfirmModal,
    customValue,
    setCustomValue,
  } = useAdvanceBoolean<string>(false);

  const actions = [
    {
      id: 'edit',
      action: 'Edit',
      as: 'Edit',
      onClick: (id: string, rowData: any) => {
        const destinationIds = rowData?.publishedRoles?.map(
          (item: any) => item.destinationCompanyId
        );
        setModalStatus('Edit');
        debugger;
        setInitialData({
          data: {
            sourceRoleId: rowData?.sourceRoleId,
            destinationCompanyId: destinationIds,
          },
          id: id,
        });
        openModal();
      },
    },
    // {
    //   action: <div className='delete-label'>Delete</div>,
    //   as: 'Delete',
    //   onClick: (id: string) => {
    //     setModalStatus('Delete');
    //     openConfirmModal();
    //     setCustomValue(id);
    //   },
    // },
  ];

  const onDeleteClick = (values: Record<string, any>): void => {
    deletePerformanceRule(customValue);
  };

  const deletePerformanceRule = (id: string): void => {
    setAlertLoading(true);
    identityHandleRequest(
      RolePublishedToCompanyService.deleteApiIdentityApiAppRolePublishedToCompany(id)
    )
      .then((data: any) => {
        if (data != null) {
          toast.success(<ToastComponent label={'Success'} message={'Published Role deleted.'} />);
          void queryClient.invalidateQueries('getRolePublishList');
          setAlertLoading(false);
          closeConfirmModal();
        }
      })
      .catch(() => {
        setAlertLoading(false);
        closeConfirmModal();
      })
      .finally(() => {
        setAlertLoading(false);
        closeConfirmModal();
      });
  };

  const renderRightToolbarButton = () => {
    return (
      <Button
        as='Create'
        variant={'primary'}
        id='addRolePublishButton'
        title={'Role Publish'}
        onClick={() => {
          setModalStatus('Add');
          setInitialData(initialValues);
          //   setRowData([]);
          openModal();
        }}
        icon='add_circle'
      />
    );
  };

  const schema = React.useMemo(
    () => ({
      columns: RolePublishHeader({ actions: schemaData?.columns, tableActions: actions }),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );

  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;
  return (
    <div data-page='rolePublish' id='pageContainer'>
      <PageHeader id='pageHeader'>
        <Heading variant='h3' title='Role Publish' id='pageTitle' />
        <Heading variant='body-s' title=' List of role for switch.' id='pageDescription' />
      </PageHeader>
      {/* <div className='grid lg:grid-cols-12 gap-4 lg:gap-1.5 items-start mb-8'>
        <div className=' col-span 12 lg:col-span-3'>
          <Search
            placeholder='Search'
            searchValue={searchQuery}
            onSearch={(value: string) => {
              setSearchQuery(value);
            }}
            setTableInfo={setTableInfo}
            tableInfo={tableInfo}
          />
        </div>
        <div className='lg:col-span-3 flex gap-4'>
          <Filter setOpen={setOpen} open={open} className='block'>
            <Heading variant='body-xs' title={'Filter By:'} className={'filter-label'} />
            <div className='grid sm:grid-cols-2 gap-x-5'>
              <FormSelect
                type='text'
                name='companyName'
                placeholder='Company'
                onChange={(value: string) => {
                  setTableInfo({ ...tableInfo });
                  setTableFilterInfo({ ...tableFilterInfo, companyName: value });
                }}
                options={destinationCompaniesOption ?? []}
                values={tableFilterInfo?.companyName}
                arrValue={tableFilterInfo?.companyName}
                containerClassName='formGroup'
                isFormik={false}
              />
              <FormSelect
                type='text'
                name='roleName'
                placeholder='Role'
                onChange={(value: string) => {
                  setTableInfo({ ...tableInfo });
                  setTableFilterInfo({ ...tableFilterInfo, roleName: value });
                }}
                options={roleOption ?? []}
                values={tableFilterInfo?.roleName}
                arrValue={tableFilterInfo?.roleName}
                containerClassName='formGroup'
                isFormik={false}
              />
            </div>
          </Filter>
          <div>
            <ResetFilterWrapper
              onClick={() => {
                setTableInfo(InitialValuesForm.tableParams);
                setTableFilterInfo({
                  companyName: '',
                  roleName: '',
                });
                setSearchQuery('');
              }}>
              <span className='material-symbols-outlined'>settings_backup_restore</span>
              <Heading variant='body-s' title='Reset Filter' />
            </ResetFilterWrapper>
          </div>
        </div>
        <div className='lg:col-span-6 flex lg:justify-end'>
          <Button
            as='Create'
            variant={'primary'}
            title={'Role Publish'}
            onClick={() => {
              setModalStatus('Add');
              setInitialData(initialValues);
              //   setRowData([]);
              openModal();
            }}
            icon='add_circle'
          />
        </div>
      </div> */}
      {isConfirmOpen && (
        <AlertPopup
          isShow={isConfirmOpen}
          closeModal={closeConfirmModal}
          customTitle={'Are you sure you want to remove Published Role?'}
          handleSubmit={onDeleteClick}
          loading={alertLoading}
        />
      )}
      <AnimationWrapper>
        {isModalOpen && (
          <RolePublishModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            modalStatus={modalStatus}
            // modalLoading={modalLoading}
            initialData={initialData}
            setModalStatus={setModalStatus}
            rowData={rowData}
            id='rolePublishModal'
          />
        )}
      </AnimationWrapper>
      <DynamicTable
        id='dataTable'
        schema={schema}
        data={data}
        totalCounts={rolePublishList?.totalCount ?? 10}
        loading={status}
        showPagination={false}
        components={{
          renderRightToolbarButton,
        }}
      />
      {/* <Table
        columns={RolePublishHeader(actions)}
        data={rolePublishList?.items ?? []}
        loading={status}
        showPagination={true}
        totalCounts={rolePublishList?.totalCount ?? 10}
        tableInfo={tableInfo}
        setTableInfo={setTableInfo}
      /> */}
    </div>
  );
};

export default withDynamicTableContext(RolePublish, false, axiosInstance);
